import React from "react";
import { Label } from "react-aria-components";
import { Label as SemanticLabel } from "semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
import { BooleanCondition } from "../../queries/getCrmRequests";
import { Controller } from "react-hook-form";
import { nestedErrorMessageSelector, IBaseControlProps } from "./Utils";

const BooleanOperatorOptions: {
  key: BooleanCondition;
  text: string;
  value: BooleanCondition;
}[] = [
  { key: "True", text: "True", value: "True" },
  { key: "False", text: "False", value: "False" },
];

interface IBooleanFilterProps {
  label: string;
  defaultOperator?: BooleanCondition;
  className?: string;
  onChange?: (values: BooleanCondition) => void;
}

export const BooleanFilter = ({ label, defaultOperator = "True", className, onChange }: IBooleanFilterProps) => {
  return (
    <div className={className}>
      <div className='tw-mb-2 tw-flex tw-w-full tw-items-center'>
        <Label className='tw-font-bold'>{label}</Label>
      </div>
      <Dropdown
        id='Boolean-operator-dropdown'
        fluid
        selection
        options={BooleanOperatorOptions}
        defaultValue={defaultOperator}
        onChange={(_, { value }) => {
          onChange?.(value as BooleanCondition);
        }}
      />
    </div>
  );
};

interface IControlledBooleanFilterProps extends IBaseControlProps, IBooleanFilterProps {}

export const ControlledBooleanFilter = ({ control, name, errors, ...props }: IControlledBooleanFilterProps) => {
  const errorMessage = nestedErrorMessageSelector(errors)(name);
  return (
    <Controller
      control={control}
      name={name}
      errors={errors}
      defaultValue={{
        booleanCondition: props.defaultOperator || "True",
        booleanValue: true,
      }}
      render={({ onChange, value: formValue }) => (
        <>
          <BooleanFilter
            {...props}
            defaultOperator={formValue?.booleanCondition || props.defaultOperator}
            onChange={(value) => {
              onChange({
                booleanCondition: value,
                booleanValue: true,
              });
              if (props.onChange) {
                props.onChange(value);
              }
            }}
          />
          {!!errorMessage && (
            <SemanticLabel className='tw-ml-0' basic prompt pointing='above'>
              {errorMessage}
            </SemanticLabel>
          )}
        </>
      )}
    />
  );
};
